import React, { useState } from "react";
import logo from "../../images/TestAssessify.png";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { useMutation, useQuery } from "react-query";
import { api } from "../../api";
import * as Yup from "yup"; // Yup for validation
import LanguageSwitcher from "../../components/LanguageSwitcher";
import { useTranslation } from "react-i18next";
import { LoaderIcon } from "react-hot-toast";
import { convertTo12Hour } from "../../utils/dateTimeFormatter";

export const strToLower = (str: any) => str?.toLowerCase()

export function greetTime() {
  const today = new Date();
  const hourOfDay = today.getHours(); // The current hour of today
  if (hourOfDay > 11 && hourOfDay <= 16) {
    return "afternoon";
  } else if (hourOfDay > 16) {
    return "evening";
  } else {
    return "morning";
  }
}

function ViewBooking() {

  const {id} = useParams();

  const { data: userBookingData, isLoading } = useQuery(
      ["User Booking Data"],
      async () => {
        const data = await api.getBookingData(id);
        return data;
      },
      {
        select: (response) => response?.data,
        enabled: Boolean(id),
      },
    );
    
  const handleDownloadQR = () => {
    if (!userBookingData?.qrCodeDataUrl) return;
    const link = document.createElement("a");
    link.href = userBookingData.qrCodeDataUrl;
    link.download = `booking-qr-${userBookingData.userExamId || "code"}.png`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };


 if(!id) return <>
      <h5 className="mt-5 text-center text-xl">Invalid Link</h5>
   </>

  return (
    <>
      <div className="bg-white p-4 lg:p-6 min-h-screen flex flex-col md:container mx-auto">
        <div className="w-full flex justify-between items-center pb-4 h-26 bg-inherit sticky top-0 cursor-pointer">
          <div className="h-full">
            <img
              src={logo}
              alt="Test Assessify"
              className="w-52 sm:w-56 h-full object-contain"
            />
          </div>
          <LanguageSwitcher />
        </div>
        <div className="flex flex-1 justify-center items-center">
          <div className="bg-cover bg-no-repeat bg-hero-img w-full md:w-[600px] lg:w-[900px] 2xl:w-[1440px] 2xl:h-[800px] rounded-xl p-2 lg:p-10 sm:shadow-2xl ">
            <div className="my-2 shadow-2xl rounded-lg bg-white w-full p-4 2xl:p-6">
              <div className="flex flex-col w-full">
                <div className="flex flex-col justify-center lg:px-4 pt-8 my-auto md:justify-start md:pt-0 2xl:px-10">
                    {/* add user booking data here */}
                    {
                        isLoading ? 
                          <div className="flex h-[200px]flex-col justify-center items-center">
                            <LoaderIcon />
                          </div>
                        :  <>
                          {  userBookingData ? (
                                <div className="flex flex-col gap-6">
                                {/* Header */}
                                <div className="text-center border-b pb-4">
                                    <h1 className="text-2xl font-bold text-gray-800">
                                    Booking Confirmation
                                    </h1>
                                    <p className="text-gray-500 mt-1">
                                    Good {greetTime()}, {userBookingData.name?.split(" ")[0]} 👋
                                    </p>
                                </div>

                                {/* QR and Booking Details */}
                                <div className="flex flex-col lg:flex-row items-center justify-between gap-8 bg-gray-50 rounded-xl p-6 shadow-sm">
                                    <div className="flex-1">
                                    <h2 className="text-lg font-semibold text-gray-700 mb-3">
                                        Exam Details
                                    </h2>
                                    <div className="space-y-2 text-gray-600">
                                        <p>
                                        <span className="font-medium text-gray-800">Exam Title:</span>{" "}
                                        {userBookingData.examTitle}
                                        </p>
                                        <p>
                                        <span className="font-medium text-gray-800">Group:</span>{" "}
                                        {userBookingData.groupTitle}
                                        </p>
                                        <p>
                                        <span className="font-medium text-gray-800">Date:</span>{" "}
                                        {userBookingData.bookedDate}
                                        </p>
                                        <p>
                                        <span className="font-medium text-gray-800">Time:</span>{" "}
                                        {convertTo12Hour(userBookingData.preferredTime)}
                                        </p>
                                    </div>

                                    <div className="mt-6">
                                        <h2 className="text-lg font-semibold text-gray-700 mb-2">
                                        Candidate Information
                                        </h2>
                                        <div className="space-y-2 text-gray-600">
                                        <p>
                                            <span className="font-medium text-gray-800">Full Name:</span>{" "}
                                            {userBookingData.name}
                                        </p>
                                        <p>
                                            <span className="font-medium text-gray-800">Email:</span>{" "}
                                            {userBookingData.email}
                                        </p>
                                        </div>
                                    </div>
                                    </div>

                                    {/* QR Code */}
                                    <div className="flex flex-col items-center">
                                    <div className="flex flex-col items-center">
                                        <img
                                            src={userBookingData.qrCodeDataUrl}
                                            alt="Booking QR Code"
                                            className="w-54 h-54 object-contain rounded-lg shadow-md"
                                        />
                                        <button
                                            onClick={handleDownloadQR}
                                            className="mt-3 px-4 py-2 bg-primary text-white text-sm font-medium rounded-lg hover:bg-primary/90 transition-all"
                                        >
                                            Download QR Code
                                        </button>
                                        <p className="text-gray-500 text-sm mt-2 text-center">
                                            Click the button to download the QR code
                                        </p>
                                        </div>

                                    </div>
                                </div>

                                {/* OTP & URL */}
                                <div className="bg-white border rounded-lg p-4 shadow-sm">
                                    <p className="text-gray-600">
                                    <span className="font-semibold text-gray-800">Booking OTP:</span>{" "}
                                    <span className="text-xl font-bold text-primary">
                                        {userBookingData.bookingOtp}
                                    </span>
                                    </p>
                                    <div className="mt-3">
                                    </div>
                                </div>

                                {/* Footer Note */}
                                <div className="text-center text-gray-500 text-sm mt-8">
                                    Please arrive at least <span className="font-medium">15 minutes early</span> 
                                    and bring a valid ID. <br />
                                    For support, contact{" "}
                                    <a
                                    href="mailto:ayo@testassessify.com."
                                    className="text-primary hover:underline"
                                    >
                                      ayo@testassessify.com.
                                    </a>
                                </div>
                                </div>
                            ) : (
                                <div className="text-center py-10 text-gray-600">
                                No booking data found for this ID.
                                </div>
                            )
                            }
                        </>
                    }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ViewBooking;